import { SystemConfigurationDto } from 'src/dtos/system-configuration.dto';
import axiosService from './axios-service';

class SystemConfigurationService {
    public getSystemConfiguration = async (): Promise<SystemConfigurationDto> => {
        const res = await axiosService.get('/api/firewall/systemConfig');
        return res?.data;
    };

    public getCurrentIPBlockedCount = async (): Promise<number> => {
        const result = await axiosService.get('/api/firewall/systemConfig/blocked-ips');
        return result?.data;
    };

}

const systemConfigurationService = new SystemConfigurationService();
export default systemConfigurationService;